import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const API_URL = "/api";

export const expancesApi = createApi({
  reducerPath: "expancesApi",
  baseQuery: fetchBaseQuery({ baseUrl: API_URL }),
  endpoints: (builder) => ({
    AddExpance: builder.mutation({
      query: ({ Token, data }) => ({
        url: "/admin/expense",
        method: "POST",
        headers: {
          Authorization: `Bearer ${Token}`,
        },
        body: data,
      }),
      // Use 'Projects' for providesTags and invalidatesTags
      providesTags: ["expances"],
      invalidatesTags: ["expances"],
    }),
    getAllExpance: builder.query({
      query: (Token) => ({
        url: "/admin/expense",
        method: "GET",
        headers: {
          Authorization: `Bearer ${Token}`,
        },
      }),
      providesTags: ["expances"],
      invalidatesTags: ["expances", "expance"],
    }),
    UpadteExpance: builder.mutation({
      query: ({ expanseId, Token, data }) => ({
        url: `/admin/expense/${expanseId}`,
        method: "PUT",
        headers: {
          Authorization: `Bearer ${Token}`,
        },
        body: data,
      }),
      // Use 'Projects' for invalidatesTags
      invalidatesTags: ["expances"],
    }),
    DeleteExpance: builder.mutation({
      query: ({ expanseId, Token }) => ({
        url: `/admin/expense/${expanseId}`,
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${Token}`,
        },
      }),
      // Use 'Projects' for invalidatesTags
      invalidatesTags: ["expances"],
    }),
    AddExpenseCategory: builder.mutation({
      query: ({ ledger, Token }) => ({
        url: `/admin/add-expense-category`,
        method: "POST",
        headers: {
          Authorization: `Bearer ${Token}`,
        },
        body: { ledger: ledger },
      }),
      // Use 'Projects' for invalidatesTags
      invalidatesTags: ["expances"],
    }),
  }),
});

export const {
  useAddExpanceMutation,
  useDeleteExpanceMutation,
  useGetAllExpanceQuery,
  useUpadteExpanceMutation,
  useAddExpenseCategoryMutation,
} = expancesApi;
